export default "__VITE_ASSET__DUy_aWBV__"